// import React, { useState, useRef, useEffect } from 'react';
// import { apiCall } from '@/api/apiCall';
// import { toast } from 'sonner';
// import { useApiQueue } from '@/hooks/useApiQueue';
// import jordan from '@/assets/img/jordan.png';
// import carParkIcon from '@/assets/img/car-park-1.png';
// import { AssetsPanel } from '../../components/shared/AssetsPanel';
// import { API_CALL_TIME } from '@/constants/constant';

// // ═══════════════════════════════════════════════════════════════════════
// // HELPERS
// // ═══════════════════════════════════════════════════════════════════════
// const groupsToFlat = (groups = []) => {
//   const result = [];
//   groups.forEach((g) => {
//     result.push({ name: g.group_name || '', isCategory: true, subCount: '', totalCount: String(g.group_total_qty ?? '-') });
//     (g.items || []).forEach((item) => {
//       result.push({ name: item.item_name || '', isCategory: false, subCount: String(item.qty ?? '-'), totalCount: '' });
//     });
//   });
//   return result;
// };

// const flatToGroups = (flat) => {
//   const groups = [];
//   let cur = null;
//   flat.forEach((a) => {
//     if (a.isCategory) {
//       if (cur) groups.push(cur);
//       cur = { group_name: a.name, group_total_qty: a.totalCount || '', items: [] };
//     } else if (cur) {
//       cur.items.push({ item_name: a.name, qty: a.subCount || '' });
//     }
//   });
//   if (cur) groups.push(cur);
//   return groups;
// };

// // ═══════════════════════════════════════════════════════════════════════
// // CONFIG
// // ═══════════════════════════════════════════════════════════════════════
// const JORDAN_PROFILE_CONFIG = {
//   profile_summary_airport_jordan: {
//     profileKey:    'jordan_airport_profile',
//     membershipKey: 'jordan_airport_membership_charges',
//     casualKey:     'jordan_airport_casual_parking_rates',
//     assetsKey:     'jordan_airport_assets_deployed',

//     profileFallback: {
//       table_key: 'jordan_airport_profile',
//       title: 'Jordan Airport Parking Profile',
//       data: {
//         car_park_bays:     { label: 'Total Off Street Car Park Bays', value: '2,228' },
//         contract_term:     { value: '14 years and 03 months' },
//         contract_period:   { start_date: '17/12/2012', end_date: '31/03/2026' },
//         operational_hours: { value: '24 Hours Per Day' },
//         vat_note:          { value: 'Parking & Membership tariffs Including 16% VAT' },
//       },
//     },

//     membershipFallback: {
//       table_key: 'jordan_airport_membership_charges',
//       title: 'Membership',
//       data: {
//         columns: [
//           { column_key: 'subscriptions', label: 'Subscriptions - MEM', type: 'text' },
//           { column_key: 'premium_parking', label: 'Premium Parking', type: 'group', sub_columns: [{ column_key: 'premium_staff', label: 'Staff' }, { column_key: 'premium_rj', label: 'RJ' }, { column_key: 'premium_nonstaff', label: 'Nonstaff' }] },
//           { column_key: 'economy_parking', label: 'Economy Parking', type: 'group', sub_columns: [{ column_key: 'economy_staff', label: 'Staff' }, { column_key: 'economy_nonstaff', label: 'Non staff' }, { column_key: 'economy_security', label: 'Security' }] },
//           { column_key: 'vip', label: 'VIP', type: 'group', sub_columns: [{ column_key: 'vip_rate', label: 'VIP' }] },
//           { column_key: 'executive', label: 'Executive', type: 'group', sub_columns: [{ column_key: 'executive_staff', label: 'Executive' }, { column_key: 'executive_nonstaff', label: 'Non staff' }] },
//           { column_key: 'cargo', label: 'Cargo', type: 'group', sub_columns: [{ column_key: 'cargo_month', label: 'Month' }, { column_key: 'cargo_annually', label: 'Annually' }] },
//         ],
//         rows: [{ subscriptions: '', premium_staff: '45 JOD', premium_rj: '40 JOD', premium_nonstaff: '90 JOD', economy_staff: '22 JOD', economy_nonstaff: '44 JOD', economy_security: '11 JOD', vip_rate: '75 JOD', executive_staff: '60 JOD', executive_nonstaff: '120 JOD', cargo_month: '5 JOD', cargo_annually: '50 JOD' }],
//         rfid_stickers_fee: '20 JOD',
//       },
//     },

//     casualFallback: {
//       table_key: 'jordan_airport_casual_parking_rates',
//       title: 'Casual Parking',
//       data: {
//         premium_and_vip:  { title: '', columns: [{ column_key: 'location', label: 'Location' }, { column_key: 'hourly_rate', label: 'Hourly Rate' }], rows: [{ location: 'Premium Exit', hourly_rate: '2.25' }, { location: 'VIP Exit', hourly_rate: '3.25' }] },
//         arrival_curbside: { title: '', columns: [{ column_key: 'location', label: 'Location' }, { column_key: '1_10_mins', label: '1 - 10 Mins' }, { column_key: '11_60_mins', label: '11 - 60 Mins' }, { column_key: 'each_additional_hour', label: 'Each Additional Hour' }], rows: [{ location: 'Arrival Curbside exit', '1_10_mins': '4', '11_60_mins': '13', each_additional_hour: '13' }] },
//         valet_service:    { title: '', columns: [{ column_key: 'location', label: 'Location' }, { column_key: '1_hour', label: '1 Hour' }, { column_key: 'each_additional_hour', label: 'Each Additional Hour' }, { column_key: 'par_day_max', label: 'Par/Day Max' }, { column_key: 'next_day', label: 'Next day' }], rows: [{ location: 'Valet Service', '1_hour': '5', each_additional_hour: '2', par_day_max: '15', next_day: 'Repeat' }] },
//         departures_exit:  { title: '', columns: [{ column_key: 'location', label: 'Location' }, { column_key: '11_20_mins', label: '11 - 20 Mins' }, { column_key: '21_60_mins', label: '21 - 60 Mins' }, { column_key: 'each_additional_hour', label: 'Each Additional Hour' }], rows: [{ location: 'Departures Exit', '11_20_mins': '4', '21_60_mins': '13', each_additional_hour: '13' }] },
//         economy_parking:  { title: '', columns: [{ column_key: 'location', label: 'Location' }, { column_key: '1_11_hrs', label: '1-11 Hrs' }, { column_key: '11_24_hours', label: '11-24 Hours' }, { column_key: 'next_day', label: 'Next Day' }], rows: [{ location: 'Economy Parking', '1_11_hrs': '1 /Hr', '11_24_hours': 'Free', next_day: 'Repeat' }] },
//         cargo_parking:    { title: '', columns: [{ column_key: 'location', label: 'Location' }, { column_key: '1_180_mins', label: '1 - 180 Mins' }, { column_key: '181_360_mins', label: '181 - 360 Mins' }, { column_key: '360_600_mins', label: '360 - 600 Mins' }, { column_key: '601_1440_mins', label: '601 - 1,440 Mins' }, { column_key: 'next_day', label: 'Next Day' }], rows: [{ location: 'Cargo Parking', '1_180_mins': '1', '181_360_mins': '2', '360_600_mins': '4', '601_1440_mins': '8', next_day: 'Repeat' }] },
//       },
//     },

//     assetsFallback: {
//       table_key: 'jordan_airport_assets_deployed',
//       title: 'Jordan Airport',
//       data: {
//         groups: [
//           { group_name: 'Ticket Dispenser',     group_total_qty: '2',  items: [{ item_name: 'DIP G100', qty: '-' }, { item_name: 'G100 64 Bit', qty: '2' }, { item_name: 'G100 32 Bit', qty: '-' }] },
//           { group_name: 'Ticket Verifier',      group_total_qty: '2',  items: [{ item_name: 'EV DIP G100', qty: '-' }, { item_name: 'EV G100 64 Bit', qty: '2' }, { item_name: 'EV G100 32 Bit', qty: '-' }] },
//           { group_name: "APM's",               group_total_qty: '2',  items: [{ item_name: 'APM ETS-70', qty: '-' }, { item_name: 'APM ETS-100', qty: '2' }] },
//           { group_name: 'PIN Pad',              group_total_qty: '-',  items: [{ item_name: 'IUP250', qty: '-' }] },
//           { group_name: 'Card Reader',          group_total_qty: '-',  items: [{ item_name: 'IUR250', qty: '-' }] },
//           { group_name: 'B-Contactless',        group_total_qty: '-',  items: [{ item_name: 'IUC150', qty: '-' }] },
//           { group_name: 'RFID Reader',          group_total_qty: '5',  items: [] },
//           { group_name: 'IP Barrier',           group_total_qty: '6',  items: [] },
//           { group_name: 'ANPR Camera',          group_total_qty: '6',  items: [{ item_name: 'ARH', qty: '6' }, { item_name: 'Lumenera', qty: '-' }] },
//           { group_name: 'Sliding Gate',         group_total_qty: '-',  items: [{ item_name: 'RIGHT', qty: '-' }, { item_name: 'LEFT', qty: '-' }] },
//           { group_name: "PND's",               group_total_qty: '-',  items: [{ item_name: 'TPAL BNA-Large', qty: '-' }, { item_name: 'T-PAL TX', qty: '-' }, { item_name: 'T-PAL V2', qty: '-' }] },
//           { group_name: 'Pound Cashier Device', group_total_qty: '-',  items: [{ item_name: 'CN-50', qty: '-' }] },
//           { group_name: 'Driver Device',        group_total_qty: '-',  items: [{ item_name: 'CN-51', qty: '-' }] },
//           { group_name: 'Enf Device',           group_total_qty: '-',  items: [{ item_name: 'Oukitel WP2', qty: '-' }, { item_name: 'Doogee V10', qty: '-' }] },
//           { group_name: 'Validation',           group_total_qty: '-',  items: [{ item_name: 'Lenova Tablet', qty: '-' }] },
//           { group_name: 'Printer',              group_total_qty: '-',  items: [{ item_name: 'PR-3', qty: '-' }, { item_name: 'SEWOO', qty: '-' }, { item_name: 'BIXOLON', qty: '-' }] },
//           { group_name: 'Tow Truck',            group_total_qty: '-',  items: [] },
//           { group_name: 'Clamp Vehicle',        group_total_qty: '-',  items: [] },
//           { group_name: 'Support Vehicle',      group_total_qty: '-',  items: [] },
//         ],
//       },
//     },
//   },
// };

// // ═══════════════════════════════════════════════════════════════════════
// // MAIN COMPONENT
// // ═══════════════════════════════════════════════════════════════════════
// const JordanAirportProfile = ({ page, year = '', monthNumber = '', contract = '' }) => {
//   const cfg = JORDAN_PROFILE_CONFIG[page?.type];
//   if (!cfg) return null;

//   const hasFetchedRef = useRef(false);
//   const saveRef       = useRef(null);
//   const [isSaving, setIsSaving] = useState(false);

//   // ── State ─────────────────────────────────────────────────────────────
//   const [profileTable, _setProfileTable] = useState(cfg.profileFallback);
//   const [membership,   _setMembership]   = useState(cfg.membershipFallback);
//   const [casual,       _setCasual]       = useState(cfg.casualFallback);
//   const [assetsTable,  _setAssetsTable]  = useState(cfg.assetsFallback);

//   // ── FIX: Refs always hold latest state ───────────────────────────────
//   const profileRef    = useRef(cfg.profileFallback);
//   const membershipRef = useRef(cfg.membershipFallback);
//   const casualRef     = useRef(cfg.casualFallback);
//   const assetsRef     = useRef(cfg.assetsFallback);

//   // ── Wrapped setters ───────────────────────────────────────────────────
//   const setProfileTable = (valOrFn) => {
//     _setProfileTable(prev => { const next = typeof valOrFn === 'function' ? valOrFn(prev) : valOrFn; profileRef.current = next; return next; });
//   };
//   const setMembership = (valOrFn) => {
//     _setMembership(prev => { const next = typeof valOrFn === 'function' ? valOrFn(prev) : valOrFn; membershipRef.current = next; return next; });
//   };
//   const setCasual = (valOrFn) => {
//     _setCasual(prev => { const next = typeof valOrFn === 'function' ? valOrFn(prev) : valOrFn; casualRef.current = next; return next; });
//   };
//   const setAssetsTable = (valOrFn) => {
//     _setAssetsTable(prev => { const next = typeof valOrFn === 'function' ? valOrFn(prev) : valOrFn; assetsRef.current = next; return next; });
//   };

//   const { enqueue } = useApiQueue();

//   // ── Fetch ─────────────────────────────────────────────────────────────
//   useEffect(() => {
//     if (hasFetchedRef.current) return;
//     hasFetchedRef.current = true;
//     fetchData();
//   }, [year, monthNumber, contract]);

//   const fetchData = async () => {
//     try {
//       const res = await enqueue(() => apiCall('GET', '/boardpack/get-tables-data', { year, contract, month: monthNumber }));
//       if (!res?.success) return;
//       const data = res?.data || [];
//       const find = (key, fb) => data.find((t) => t.table_key === key) || fb;
//       setProfileTable(find(cfg.profileKey,    cfg.profileFallback));
//       setMembership(find(cfg.membershipKey,   cfg.membershipFallback));
//       setCasual(find(cfg.casualKey,           cfg.casualFallback));
//       setAssetsTable(find(cfg.assetsKey,      cfg.assetsFallback));
//     } catch (err) {
//       console.error('Fetch error:', err);
//     }
//   };

//   // ── Auto-save ─────────────────────────────────────────────────────────
//   const autoSave = () => {
//     if (saveRef.current) clearTimeout(saveRef.current);
//     saveRef.current = setTimeout(saveToAPI, API_CALL_TIME);
//   };

//   // FIX: Reads from refs — always latest
//   const saveToAPI = async () => {
//     try {
//       setIsSaving(true);
//       const res = await apiCall('POST', '/boardpack/add-tables-data', {
//         contract, year, month: monthNumber, created_by: 1,
//         tables: [
//           { table_key: profileRef.current.table_key,    title: profileRef.current.title,    data: profileRef.current.data    },
//           { table_key: membershipRef.current.table_key, title: membershipRef.current.title, data: membershipRef.current.data },
//           { table_key: casualRef.current.table_key,     title: casualRef.current.title,     data: casualRef.current.data     },
//           { table_key: assetsRef.current.table_key,     title: assetsRef.current.title,     data: assetsRef.current.data     },
//         ],
//       });
//       if (!res?.success) throw new Error(res?.message);
//     } catch (err) {
//       console.error('Save error:', err);
//       toast.error('Failed to save changes');
//     } finally {
//       setIsSaving(false);
//     }
//   };

//   // ── Patch helpers ─────────────────────────────────────────────────────
//   const patchProfile = (field, subField, value) => {
//     setProfileTable((prev) => ({ ...prev, data: { ...prev.data, [field]: subField ? { ...prev.data[field], [subField]: value } : value } }));
//     autoSave();
//   };

//   const patchMembershipCell = (rowIdx, colKey, value) => {
//     setMembership((prev) => ({ ...prev, data: { ...prev.data, rows: prev.data.rows.map((row, i) => (i === rowIdx ? { ...row, [colKey]: value } : row)) } }));
//     autoSave();
//   };

//   const patchMembershipRFID = (value) => {
//     setMembership((prev) => ({ ...prev, data: { ...prev.data, rfid_stickers_fee: value } }));
//     autoSave();
//   };

//   const patchCasualCell = (sectionKey, rowIdx, colKey, value) => {
//     setCasual((prev) => ({ ...prev, data: { ...prev.data, [sectionKey]: { ...prev.data[sectionKey], rows: prev.data[sectionKey].rows.map((r, i) => (i === rowIdx ? { ...r, [colKey]: value } : r)) } } }));
//     autoSave();
//   };

//   const handleAssetSubCount = (flatIdx, value) => {
//     // FIX: use assetsRef.current for latest groups
//     const flat = groupsToFlat(assetsRef.current.data.groups).map((a, i) => (i === flatIdx ? { ...a, subCount: value } : a));
//     setAssetsTable((prev) => ({ ...prev, data: { ...prev.data, groups: flatToGroups(flat) } }));
//     autoSave();
//   };

//   const handleAssetTotalCount = (flatIdx, value) => {
//     // FIX: use assetsRef.current for latest groups
//     const flat = groupsToFlat(assetsRef.current.data.groups).map((a, i) => (i === flatIdx ? { ...a, totalCount: value } : a));
//     setAssetsTable((prev) => ({ ...prev, data: { ...prev.data, groups: flatToGroups(flat) } }));
//     autoSave();
//   };

//   // ── Derived ───────────────────────────────────────────────────────────
//   const pd         = profileTable.data;
//   const md         = membership.data;
//   const cd         = casual.data;
//   const flatAssets = groupsToFlat(assetsTable.data.groups);

//   const membershipLeafKeys = [
//     'premium_staff', 'premium_rj', 'premium_nonstaff',
//     'economy_staff', 'economy_nonstaff', 'economy_security',
//     'vip_rate',
//     'executive_staff', 'executive_nonstaff',
//     'cargo_month', 'cargo_annually',
//   ];

//   // ── RENDER ────────────────────────────────────────────────────────────
//   return (
//     <div className="min-h-screen bg-white p-4 md:p-6 lg:p-8 text-[13px]">
//       <div className="flex justify-between items-center mb-3">
//         <div className="ml-2"><img src={jordan} alt="Jordan Airport Logo" style={{ height: '50px', objectFit: 'contain' }} /></div>
//         <h1 className="text-xl font-bold flex-1 text-center">{profileTable.title}</h1>
//       </div>

//       <div className="flex flex-col lg:flex-row gap-0 !border-2 !border-black p-4">
//         <div className="flex-1 pr-4">

//           <div className="flex items-center gap-2 mb-1 ml-4 mt-2">
//             <img src={carParkIcon} alt="car park" style={{ height: '48px', objectFit: 'contain' }} />
//             <span className="text-[12px]">
//               {pd.car_park_bays?.label}{' '}
//               <strong><input type="text" value={pd.car_park_bays?.value || ''} onChange={e => patchProfile('car_park_bays', 'value', e.target.value)} className="font-bold outline-none bg-transparent !border-0 text-[12px] w-16" /></strong>
//             </span>
//           </div>

//           <div className="flex items-start gap-2 mb-1 ml-10">
//             <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
//             <span className="text-[12px] flex items-center flex-wrap gap-1">
//               Contract term{' '}
//               <strong><input type="text" value={pd.contract_term?.value || ''} onChange={e => patchProfile('contract_term', 'value', e.target.value)} className="font-bold outline-none bg-transparent !border-0 text-[12px] w-36" /></strong>
//               ; start date{' '}
//               <strong><input type="text" value={pd.contract_period?.start_date || ''} onChange={e => patchProfile('contract_period', 'start_date', e.target.value)} className="font-bold outline-none bg-transparent !border-0 text-[12px] w-16" /></strong>
//               {' to '}
//               <strong><input type="text" value={pd.contract_period?.end_date || ''} onChange={e => patchProfile('contract_period', 'end_date', e.target.value)} className="font-bold outline-none bg-transparent !border-0 text-[12px]" /></strong>
//             </span>
//           </div>

//           <div className="flex items-center gap-2 mb-1 ml-10">
//             <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
//             <span className="text-[12px]">
//               Operational Hours{' '}
//               <strong><input type="text" value={pd.operational_hours?.value || ''} onChange={e => patchProfile('operational_hours', 'value', e.target.value)} className="font-bold outline-none bg-transparent !border-0 text-[12px]" /></strong>
//             </span>
//           </div>

//           <div className="flex items-center gap-2 mb-1 ml-10">
//                <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
//             <span className="text-[12px] text-red-600">
//               <input type="text" value={pd.vat_note?.value || ''} onChange={e => patchProfile('vat_note', 'value', e.target.value)} className="outline-none bg-transparent !border-0 text-[12px] w-80 text-black" />
//             </span>
//           </div>
//           {/* ─── New Assets Deployed Section ─── */}
//           <div className="flex items-center gap-2 mb-3 ml-10">
//   <div className="w-3 h-3 rounded-full bg-red-500 flex-shrink-0" />
//   <span className="text-[12px]">
//     Assets deployed{' '}
//     <strong>
//       <input
//         type="text"
//         value={pd.assets_deployed?.value || ''}
//         onChange={e => patchProfile('assets_deployed', 'value', e.target.value)}
//         className="font-bold outline-none bg-transparent !border-0 text-[12px] w-40"
//       />
//     </strong>
//   </span>
// </div>
//           {/* Membership Table */}
//           <div className="ml-4 mb-6">
//             <div className="font-bold text-[13px] mb-1">{membership.title}</div>
//             <div className="">
//               <table className="!border-collapse text-[11px]">
//               <thead>
//   {/* Row 1 */}
//   <tr className="bg-gray-200">
//     {md.columns.map((col) => (
//       <th
//         key={col.column_key}
//         colSpan={col.type === 'group' ? col.sub_columns.length : 1}
//         className="!border !border-black px-2 py-1 font-bold text-center align-middle"
//       >
//         {col.label}
//       </th>
//     ))}
//   </tr>

//   {/* Row 2 */}
//   <tr className="bg-white">
//     {md.columns.map((col) =>
//       col.type === 'group'
//         ? col.sub_columns.map((sub) => (
//             <th
//               key={sub.column_key}
//               className="!border !border-black px-1 py-0.5 text-[10px] font-medium text-center"
//             >
//               {sub.label}
//             </th>
//           ))
//         : (
//           // ✅ YE IMPORTANT HAI
//           <th
//   key={col.column_key}
//   className="!border-l !border-r !border-black !border-b-0 px-1 py-0.5"
// ></th>
//         )
//     )}
//   </tr>
// </thead>
//                 <tbody>
//                   {md.rows.map((row, ri) => (
//                     <tr key={ri}>
//                       <td className="!border-l !border-r !border-b !border-black !border-t-0 px-2 py-1 text-center">
//                         <input type="text" value={row.subscriptions || ''} onChange={e => patchMembershipCell(ri, 'subscriptions', e.target.value)} className="w-full text-center bg-transparent outline-none text-[11px]" />
//                       </td>
//                       {membershipLeafKeys.map((key) => (
//                         <td key={key} className="!border !border-black px-2 py-1 text-center">
//                           <input type="text" value={row[key] || ''} onChange={e => patchMembershipCell(ri, key, e.target.value)} className="w-full text-center bg-transparent outline-none text-[11px]" />
//                         </td>
//                       ))}
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>
//             <table className="!border !border-black text-[11px] mt-4 bg-gray-200">
//               <tbody>
//                 <tr>
//                   <td className="text-left font-semibold px-3 border border-black">RFID stickers fee:</td>
//                   <td className="!border !border-black px-2 py-1">
//                     <input type="text" value={md.rfid_stickers_fee || ''} onChange={e => patchMembershipRFID(e.target.value)} className="w-20 text-[12px] font-bold text-center border border-black border-collapse rounded" />
//                   </td>
//                 </tr>
//               </tbody>
//             </table>
//           </div>

//           {/* Casual Parking */}
//           <div className="ml-4">
//             <div className="font-bold text-[13px] mb-2">{casual.title}</div>
//             {Object.entries(cd).map(([sectionKey, section]) => (
//               <div key={sectionKey} className="mb-5">
//                 <div className="font-semibold text-[11px] mb-1">{section.title}</div>
//                 <table className="!border-collapse text-[11px]">
//                   <thead>
//                     <tr className="bg-gray-200">
//                       {section.columns.map((col, i) => (
//                         <th key={i} className="!border !border-black px-2 py-1 text-center font-medium">{col.label || col}</th>
//                       ))}
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {section.rows.map((row, ri) => (
//                       <tr key={ri}>
//                         {section.columns.map((col, ci) => {
//                           const ck = col.column_key || (typeof col === 'string' ? col.toLowerCase().replace(/\s+/g, '_') : '');
//                           return (
//                             <td key={ci} className="!border !border-black px-2 py-1 text-center">
//                               {ck === 'location' ? (
//                                 <span className="text-[11px]">{row.location}</span>
//                               ) : (
//                                 <input type="text" value={row[ck] || ''} onChange={e => patchCasualCell(sectionKey, ri, ck, e.target.value)} className="w-full text-center bg-transparent outline-none text-[11px]" />
//                               )}
//                             </td>
//                           );
//                         })}
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               </div>
//             ))}
//           </div>
//         </div>

//          {/* ══ RIGHT — Assets Panel ══ */}
//               <AssetsPanel
//                   assetsTable={{ title: assetsTable.title }}
//                   flatAssets={flatAssets}
//                   onSubCount={handleAssetSubCount}
//                   onTotalCount={handleAssetTotalCount}
//                 />
//       </div>
//     </div>
//   );
// };

// export default JordanAirportProfile;










import React, { useState, useRef, useEffect } from 'react';
import { apiCall } from '@/api/apiCall';
import { toast } from 'sonner';
import { useApiQueue } from '@/hooks/useApiQueue';
import jordan from '@/assets/img/jordan.png';
import carParkIcon from '@/assets/img/car-park-1.png';
import { AssetsPanel } from '../../components/shared/AssetsPanel';
import { API_CALL_TIME } from '@/constants/constant';

// ═══════════════════════════════════════════════════════════════════════
// HELPERS
// ═══════════════════════════════════════════════════════════════════════
const groupsToFlat = (groups = []) => {
  const result = [];
  groups.forEach((g) => {
    result.push({ name: g.group_name || '', isCategory: true, subCount: '', totalCount: String(g.group_total_qty ?? '-') });
    (g.items || []).forEach((item) => {
      result.push({ name: item.item_name || '', isCategory: false, subCount: String(item.qty ?? '-'), totalCount: '' });
    });
  });
  return result;
};

const flatToGroups = (flat) => {
  const groups = [];
  let cur = null;
  flat.forEach((a) => {
    if (a.isCategory) {
      if (cur) groups.push(cur);
      cur = { group_name: a.name, group_total_qty: a.totalCount || '', items: [] };
    } else if (cur) {
      cur.items.push({ item_name: a.name, qty: a.subCount || '' });
    }
  });
  if (cur) groups.push(cur);
  return groups;
};

// ═══════════════════════════════════════════════════════════════════════
// CONFIG
// ═══════════════════════════════════════════════════════════════════════
const JORDAN_PROFILE_CONFIG = {
  profile_summary_airport_jordan: {
    profileKey:    'jordan_airport_profile',
    membershipKey: 'jordan_airport_membership_charges',
    casualKey:     'jordan_airport_casual_parking_rates',
    assetsKey:     'jordan_airport_assets_deployed',

    profileFallback: {
      table_key: 'jordan_airport_profile',
      title: 'Jordan Airport Parking Profile',
      data: {
        car_park_bays:     { label: 'Total Off Street Car Park Bays', value: '2,228' },
        contract_term:     { value: '14 years and 03 months' },
        contract_period:   { start_date: '17/12/2012', end_date: '31/03/2026' },
        operational_hours: { value: '24 Hours Per Day' },
        vat_note:          { value: 'Parking & Membership tariffs Including 16% VAT' },
      },
    },

    membershipFallback: {
      table_key: 'jordan_airport_membership_charges',
      title: 'Membership',
      data: {
        columns: [
          { column_key: 'subscriptions', label: 'Subscriptions - MEM', type: 'text' },
          { column_key: 'premium_parking', label: 'Premium Parking', type: 'group', sub_columns: [{ column_key: 'premium_staff', label: 'Staff' }, { column_key: 'premium_rj', label: 'RJ' }, { column_key: 'premium_nonstaff', label: 'Nonstaff' }] },
          { column_key: 'economy_parking', label: 'Economy Parking', type: 'group', sub_columns: [{ column_key: 'economy_staff', label: 'Staff' }, { column_key: 'economy_nonstaff', label: 'Non staff' }, { column_key: 'economy_security', label: 'Security' }] },
          { column_key: 'vip', label: 'VIP', type: 'group', sub_columns: [{ column_key: 'vip_rate', label: 'VIP' }] },
          { column_key: 'executive', label: 'Executive', type: 'group', sub_columns: [{ column_key: 'executive_staff', label: 'Executive' }, { column_key: 'executive_nonstaff', label: 'Non staff' }] },
          { column_key: 'cargo', label: 'Cargo', type: 'group', sub_columns: [{ column_key: 'cargo_month', label: 'Month' }, { column_key: 'cargo_annually', label: 'Annually' }] },
        ],
        rows: [{ subscriptions: '', premium_staff: '45 JOD', premium_rj: '40 JOD', premium_nonstaff: '90 JOD', economy_staff: '22 JOD', economy_nonstaff: '44 JOD', economy_security: '11 JOD', vip_rate: '75 JOD', executive_staff: '60 JOD', executive_nonstaff: '120 JOD', cargo_month: '5 JOD', cargo_annually: '50 JOD' }],
        rfid_stickers_fee: '20 JOD',
      },
    },

    casualFallback: {
      table_key: 'jordan_airport_casual_parking_rates',
      title: 'Casual Parking',
      data: {
        premium_and_vip:  { title: '', columns: [{ column_key: 'location', label: 'Location' }, { column_key: 'hourly_rate', label: 'Hourly Rate' }], rows: [{ location: 'Premium Exit', hourly_rate: '2.25' }, { location: 'VIP Exit', hourly_rate: '3.25' }] },
        arrival_curbside: { title: '', columns: [{ column_key: 'location', label: 'Location' }, { column_key: '1_10_mins', label: '1 - 10 Mins' }, { column_key: '11_60_mins', label: '11 - 60 Mins' }, { column_key: 'each_additional_hour', label: 'Each Additional Hour' }], rows: [{ location: 'Arrival Curbside exit', '1_10_mins': '4', '11_60_mins': '13', each_additional_hour: '13' }] },
        valet_service:    { title: '', columns: [{ column_key: 'location', label: 'Location' }, { column_key: '1_hour', label: '1 Hour' }, { column_key: 'each_additional_hour', label: 'Each Additional Hour' }, { column_key: 'par_day_max', label: 'Par/Day Max' }, { column_key: 'next_day', label: 'Next day' }], rows: [{ location: 'Valet Service', '1_hour': '5', each_additional_hour: '2', par_day_max: '15', next_day: 'Repeat' }] },
        departures_exit:  { title: '', columns: [{ column_key: 'location', label: 'Location' }, { column_key: '11_20_mins', label: '11 - 20 Mins' }, { column_key: '21_60_mins', label: '21 - 60 Mins' }, { column_key: 'each_additional_hour', label: 'Each Additional Hour' }], rows: [{ location: 'Departures Exit', '11_20_mins': '4', '21_60_mins': '13', each_additional_hour: '13' }] },
        economy_parking:  { title: '', columns: [{ column_key: 'location', label: 'Location' }, { column_key: '1_11_hrs', label: '1-11 Hrs' }, { column_key: '11_24_hours', label: '11-24 Hours' }, { column_key: 'next_day', label: 'Next Day' }], rows: [{ location: 'Economy Parking', '1_11_hrs': '1 /Hr', '11_24_hours': 'Free', next_day: 'Repeat' }] },
        cargo_parking:    { title: '', columns: [{ column_key: 'location', label: 'Location' }, { column_key: '1_180_mins', label: '1 - 180 Mins' }, { column_key: '181_360_mins', label: '181 - 360 Mins' }, { column_key: '360_600_mins', label: '360 - 600 Mins' }, { column_key: '601_1440_mins', label: '601 - 1,440 Mins' }, { column_key: 'next_day', label: 'Next Day' }], rows: [{ location: 'Cargo Parking', '1_180_mins': '1', '181_360_mins': '2', '360_600_mins': '4', '601_1440_mins': '8', next_day: 'Repeat' }] },
      },
    },

    assetsFallback: {
      table_key: 'jordan_airport_assets_deployed',
      title: 'Jordan Airport',
      data: {
        groups: [
          { group_name: 'Ticket Dispenser',     group_total_qty: '2',  items: [{ item_name: 'DIP G100', qty: '-' }, { item_name: 'G100 64 Bit', qty: '2' }, { item_name: 'G100 32 Bit', qty: '-' }] },
          { group_name: 'Ticket Verifier',      group_total_qty: '2',  items: [{ item_name: 'EV DIP G100', qty: '-' }, { item_name: 'EV G100 64 Bit', qty: '2' }, { item_name: 'EV G100 32 Bit', qty: '-' }] },
          { group_name: "APM's",               group_total_qty: '2',  items: [{ item_name: 'APM ETS-70', qty: '-' }, { item_name: 'APM ETS-100', qty: '2' }] },
          { group_name: 'PIN Pad',              group_total_qty: '-',  items: [{ item_name: 'IUP250', qty: '-' }] },
          { group_name: 'Card Reader',          group_total_qty: '-',  items: [{ item_name: 'IUR250', qty: '-' }] },
          { group_name: 'B-Contactless',        group_total_qty: '-',  items: [{ item_name: 'IUC150', qty: '-' }] },
          { group_name: 'RFID Reader',          group_total_qty: '5',  items: [] },
          { group_name: 'IP Barrier',           group_total_qty: '6',  items: [] },
          { group_name: 'ANPR Camera',          group_total_qty: '6',  items: [{ item_name: 'ARH', qty: '6' }, { item_name: 'Lumenera', qty: '-' }] },
          { group_name: 'Sliding Gate',         group_total_qty: '-',  items: [{ item_name: 'RIGHT', qty: '-' }, { item_name: 'LEFT', qty: '-' }] },
          { group_name: "PND's",               group_total_qty: '-',  items: [{ item_name: 'TPAL BNA-Large', qty: '-' }, { item_name: 'T-PAL TX', qty: '-' }, { item_name: 'T-PAL V2', qty: '-' }] },
          { group_name: 'Pound Cashier Device', group_total_qty: '-',  items: [{ item_name: 'CN-50', qty: '-' }] },
          { group_name: 'Driver Device',        group_total_qty: '-',  items: [{ item_name: 'CN-51', qty: '-' }] },
          { group_name: 'Enf Device',           group_total_qty: '-',  items: [{ item_name: 'Oukitel WP2', qty: '-' }, { item_name: 'Doogee V10', qty: '-' }] },
          { group_name: 'Validation',           group_total_qty: '-',  items: [{ item_name: 'Lenova Tablet', qty: '-' }] },
          { group_name: 'Printer',              group_total_qty: '-',  items: [{ item_name: 'PR-3', qty: '-' }, { item_name: 'SEWOO', qty: '-' }, { item_name: 'BIXOLON', qty: '-' }] },
          { group_name: 'Tow Truck',            group_total_qty: '-',  items: [] },
          { group_name: 'Clamp Vehicle',        group_total_qty: '-',  items: [] },
          { group_name: 'Support Vehicle',      group_total_qty: '-',  items: [] },
        ],
      },
    },
  },
};

// ═══════════════════════════════════════════════════════════════════════
// MAIN COMPONENT
// ═══════════════════════════════════════════════════════════════════════
const JordanAirportProfile = ({ page, year = '', monthNumber = '', month = '', contract = '' }) => {
  const cfg = JORDAN_PROFILE_CONFIG[page?.type];
  if (!cfg) return null;

  const hasFetchedRef = useRef(false);
  const saveRef       = useRef(null);
  const [isSaving, setIsSaving] = useState(false);

  // 🔥 State for second API (parking bays)
  const [parkingBaysData, setParkingBaysData] = useState(null);

  // ── State ─────────────────────────────────────────────────────────────
  const [profileTable, _setProfileTable] = useState(cfg.profileFallback);
  const [membership,   _setMembership]   = useState(cfg.membershipFallback);
  const [casual,       _setCasual]       = useState(cfg.casualFallback);
  const [assetsTable,  _setAssetsTable]  = useState(cfg.assetsFallback);

  // ── FIX: Refs always hold latest state ───────────────────────────────
  const profileRef    = useRef(cfg.profileFallback);
  const membershipRef = useRef(cfg.membershipFallback);
  const casualRef     = useRef(cfg.casualFallback);
  const assetsRef     = useRef(cfg.assetsFallback);

  // ── Wrapped setters ───────────────────────────────────────────────────
  const setProfileTable = (valOrFn) => {
    _setProfileTable(prev => { const next = typeof valOrFn === 'function' ? valOrFn(prev) : valOrFn; profileRef.current = next; return next; });
  };
  const setMembership = (valOrFn) => {
    _setMembership(prev => { const next = typeof valOrFn === 'function' ? valOrFn(prev) : valOrFn; membershipRef.current = next; return next; });
  };
  const setCasual = (valOrFn) => {
    _setCasual(prev => { const next = typeof valOrFn === 'function' ? valOrFn(prev) : valOrFn; casualRef.current = next; return next; });
  };
  const setAssetsTable = (valOrFn) => {
    _setAssetsTable(prev => { const next = typeof valOrFn === 'function' ? valOrFn(prev) : valOrFn; assetsRef.current = next; return next; });
  };

  const { enqueue } = useApiQueue();

  // 🔥 Effective total bays - second API se aayega, nahi toh fallback
  const effectiveTotalBays = parkingBaysData?.total_bays ?? profileTable.data.car_park_bays?.value ?? '0';

  // ── Fetch BOTH APIs ─────────────────────────────────────────────────────────────
  useEffect(() => {
    if (hasFetchedRef.current) return;
    hasFetchedRef.current = true;
    fetchAllData();
  }, [year, month, monthNumber, contract]);

  const fetchAllData = async () => {
    try {
      // 🔥 Second API params - 'type' not 'value'
      const secondApiParams = {
        contract: "1200100",
        year: year,
        month: month,     // using 'month' (string like "Oct")
        type: "airport"
      };
      
      const [firstApiResponse, secondApiResponse] = await Promise.all([
        enqueue(() => apiCall('GET', '/boardpack/get-tables-data', { year, contract, month: monthNumber })),
        enqueue(() => apiCall('GET', '/boardpack/parking/bays', secondApiParams))
      ]);

      // Process first API response
      if (firstApiResponse?.success) {
        const data = firstApiResponse?.data || [];
        const find = (key, fb) => data.find((t) => t.table_key === key) || fb;
        setProfileTable(find(cfg.profileKey,    cfg.profileFallback));
        setMembership(find(cfg.membershipKey,   cfg.membershipFallback));
        setCasual(find(cfg.casualKey,           cfg.casualFallback));
        setAssetsTable(find(cfg.assetsKey,      cfg.assetsFallback));
      }

      // 🔥 Process second API response for parking bays
      if (secondApiResponse?.success && secondApiResponse?.data) {
        setParkingBaysData(secondApiResponse.data);
      } else {
        console.warn("Second API failed:", secondApiResponse?.message);
        setParkingBaysData(null);
      }
      
    } catch (err) {
      console.error('Fetch error:', err);
    }
  };

  // ── Auto-save ─────────────────────────────────────────────────────────
  const autoSave = () => {
    if (saveRef.current) clearTimeout(saveRef.current);
    saveRef.current = setTimeout(saveToAPI, API_CALL_TIME);
  };

  const saveToAPI = async () => {
    try {
      setIsSaving(true);
      const res = await apiCall('POST', '/boardpack/add-tables-data', {
        contract, year, month: monthNumber, created_by: 1,
        tables: [
          { table_key: profileRef.current.table_key,    title: profileRef.current.title,    data: profileRef.current.data    },
          { table_key: membershipRef.current.table_key, title: membershipRef.current.title, data: membershipRef.current.data },
          { table_key: casualRef.current.table_key,     title: casualRef.current.title,     data: casualRef.current.data     },
          { table_key: assetsRef.current.table_key,     title: assetsRef.current.title,     data: assetsRef.current.data     },
        ],
      });
      if (!res?.success) throw new Error(res?.message);
    } catch (err) {
      console.error('Save error:', err);
      toast.error('Failed to save changes');
    } finally {
      setIsSaving(false);
    }
  };

  // ── Patch helpers ─────────────────────────────────────────────────────
  const patchProfile = (field, subField, value) => {
    setProfileTable((prev) => ({ ...prev, data: { ...prev.data, [field]: subField ? { ...prev.data[field], [subField]: value } : value } }));
    autoSave();
  };

  const patchMembershipCell = (rowIdx, colKey, value) => {
    setMembership((prev) => ({ ...prev, data: { ...prev.data, rows: prev.data.rows.map((row, i) => (i === rowIdx ? { ...row, [colKey]: value } : row)) } }));
    autoSave();
  };

  const patchMembershipRFID = (value) => {
    setMembership((prev) => ({ ...prev, data: { ...prev.data, rfid_stickers_fee: value } }));
    autoSave();
  };

  const patchCasualCell = (sectionKey, rowIdx, colKey, value) => {
    setCasual((prev) => ({ ...prev, data: { ...prev.data, [sectionKey]: { ...prev.data[sectionKey], rows: prev.data[sectionKey].rows.map((r, i) => (i === rowIdx ? { ...r, [colKey]: value } : r)) } } }));
    autoSave();
  };

  const handleAssetSubCount = (flatIdx, value) => {
    const flat = groupsToFlat(assetsRef.current.data.groups).map((a, i) => (i === flatIdx ? { ...a, subCount: value } : a));
    setAssetsTable((prev) => ({ ...prev, data: { ...prev.data, groups: flatToGroups(flat) } }));
    autoSave();
  };

  const handleAssetTotalCount = (flatIdx, value) => {
    const flat = groupsToFlat(assetsRef.current.data.groups).map((a, i) => (i === flatIdx ? { ...a, totalCount: value } : a));
    setAssetsTable((prev) => ({ ...prev, data: { ...prev.data, groups: flatToGroups(flat) } }));
    autoSave();
  };

  // ── Derived ───────────────────────────────────────────────────────────
  const pd         = profileTable.data;
  const md         = membership.data;
  const cd         = casual.data;
  const flatAssets = groupsToFlat(assetsTable.data.groups);

  const membershipLeafKeys = [
    'premium_staff', 'premium_rj', 'premium_nonstaff',
    'economy_staff', 'economy_nonstaff', 'economy_security',
    'vip_rate',
    'executive_staff', 'executive_nonstaff',
    'cargo_month', 'cargo_annually',
  ];

  // ── RENDER ────────────────────────────────────────────────────────────
  return (
    <div className="min-h-screen bg-white p-8 text-[13px]">
      <div className="flex justify-between items-center mb-3">
        <div className="ml-2"><img src={jordan} alt="Jordan Airport Logo" style={{ height: '50px', objectFit: 'contain' }} /></div>
        <h1 className="text-xl font-bold flex-1 text-center">{profileTable.title}</h1>
      </div>

      <div className="flex flex-row gap-0 !border-2 !border-black p-4">
        <div className="flex-1 pr-4">

          {/* 🔥 READ-ONLY Total Bays - Second API se aayega */}
          <div className="flex items-center gap-2 mb-1 ml-4 mt-2">
            <img src={carParkIcon} alt="car park" style={{ height: '48px', objectFit: 'contain' }} />
            <span className="text-[12px]">
              {pd.car_park_bays?.label}{' '}
              <strong>
                <input 
                  type="text" 
                  value={effectiveTotalBays} 
                  readOnly 
                  disabled
                  className="font-bold outline-none bg-transparent !border-0 text-[12px] w-16 cursor-default"
                />
              </strong>
            </span>
          </div>

          <div className="flex items-start gap-2 mb-1 ml-10">
            <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
            <span className="text-[12px] flex items-center flex-wrap gap-1">
              Contract term{' '}
              <strong><input type="text" value={pd.contract_term?.value || ''} onChange={e => patchProfile('contract_term', 'value', e.target.value)} className="font-bold outline-none bg-transparent !border-0 text-[12px] w-36" /></strong>
              ; start date{' '}
              <strong><input type="text" value={pd.contract_period?.start_date || ''} onChange={e => patchProfile('contract_period', 'start_date', e.target.value)} className="font-bold outline-none bg-transparent !border-0 text-[12px] w-16" /></strong>
              {' to '}
              <strong><input type="text" value={pd.contract_period?.end_date || ''} onChange={e => patchProfile('contract_period', 'end_date', e.target.value)} className="font-bold outline-none bg-transparent !border-0 text-[12px]" /></strong>
            </span>
          </div>

          <div className="flex items-center gap-2 mb-1 ml-10">
            <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
            <span className="text-[12px]">
              Operational Hours{' '}
              <strong><input type="text" value={pd.operational_hours?.value || ''} onChange={e => patchProfile('operational_hours', 'value', e.target.value)} className="font-bold outline-none bg-transparent !border-0 text-[12px]" /></strong>
            </span>
          </div>

          <div className="flex items-center gap-2 mb-1 ml-10">
            <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
            <span className="text-[12px] text-red-600">
              <input type="text" value={pd.vat_note?.value || ''} onChange={e => patchProfile('vat_note', 'value', e.target.value)} className="outline-none bg-transparent !border-0 text-[12px] w-80 text-black" />
            </span>
          </div>

          {/* Assets Deployed Section */}
          <div className="flex items-center gap-2 mb-3 ml-10">
            <div className="w-3 h-3 rounded-full bg-red-500 flex-shrink-0" />
            <span className="text-[12px]">
              Assets deployed{' '}
              <strong>
                <input
                  type="text"
                  value={pd.assets_deployed?.value || ''}
                  onChange={e => patchProfile('assets_deployed', 'value', e.target.value)}
                  className="font-bold outline-none bg-transparent !border-0 text-[12px] w-40"
                />
              </strong>
            </span>
          </div>

          {/* Membership Table */}
          <div className="ml-4 mb-6">
            <div className="font-bold text-[13px] mb-1">{membership.title}</div>
            <div className="">
              <table className="!border-collapse text-[11px]">
                <thead>
                  <tr className="bg-gray-200">
                    {md.columns.map((col) => (
                      <th
                        key={col.column_key}
                        colSpan={col.type === 'group' ? col.sub_columns.length : 1}
                        className="!border !border-black px-2 py-1 font-bold text-center align-middle"
                      >
                        {col.label}
                      </th>
                    ))}
                  </tr>
                  <tr className="bg-white">
                    {md.columns.map((col) =>
                      col.type === 'group'
                        ? col.sub_columns.map((sub) => (
                            <th
                              key={sub.column_key}
                              className="!border !border-black px-1 py-0.5 text-[10px] font-medium text-center"
                            >
                              {sub.label}
                            </th>
                          ))
                        : (
                          <th
                            key={col.column_key}
                            className="!border-l !border-r !border-black !border-b-0 px-1 py-0.5"
                          ></th>
                        )
                    )}
                  </tr>
                </thead>
                <tbody>
                  {md.rows.map((row, ri) => (
                    <tr key={ri}>
                      <td className="!border-l !border-r !border-b !border-black !border-t-0 px-2 py-1 text-center">
                        <input type="text" value={row.subscriptions || ''} onChange={e => patchMembershipCell(ri, 'subscriptions', e.target.value)} className="w-full text-center bg-transparent outline-none text-[11px]" />
                      </td>
                      {membershipLeafKeys.map((key) => (
                        <td key={key} className="!border !border-black px-2 py-1 text-center">
                          <input type="text" value={row[key] || ''} onChange={e => patchMembershipCell(ri, key, e.target.value)} className="w-full text-center bg-transparent outline-none text-[11px]" />
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <table className="!border !border-black text-[11px] mt-4 bg-gray-200">
              <tbody>
                <tr>
                  <td className="text-left font-semibold px-3 border border-black">RFID stickers fee:</td>
                  <td className="!border !border-black px-2 py-1">
                    <input type="text" value={md.rfid_stickers_fee || ''} onChange={e => patchMembershipRFID(e.target.value)} className="w-20 text-[12px] font-bold text-center border border-black border-collapse rounded" />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          {/* Casual Parking */}
          <div className="ml-4">
            <div className="font-bold text-[13px] mb-2">{casual.title}</div>
            {Object.entries(cd).map(([sectionKey, section]) => (
              <div key={sectionKey} className="mb-5">
                <div className="font-semibold text-[11px] mb-1">{section.title}</div>
                <table className="!border-collapse text-[11px]">
                  <thead>
                    <tr className="bg-gray-200">
                      {section.columns.map((col, i) => (
                        <th key={i} className="!border !border-black px-2 py-1 text-center font-medium">{col.label || col}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {section.rows.map((row, ri) => (
                      <tr key={ri}>
                        {section.columns.map((col, ci) => {
                          const ck = col.column_key || (typeof col === 'string' ? col.toLowerCase().replace(/\s+/g, '_') : '');
                          return (
                            <td key={ci} className="!border !border-black px-2 py-1 text-center">
                              {ck === 'location' ? (
                                <span className="text-[11px]">{row.location}</span>
                              ) : (
                                <input type="text" value={row[ck] || ''} onChange={e => patchCasualCell(sectionKey, ri, ck, e.target.value)} className="w-full text-center bg-transparent outline-none text-[11px]" />
                              )}
                            </td>
                          );
                        })}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ))}
          </div>
        </div>

        {/* ══ RIGHT — Assets Panel ══ */}
        <AssetsPanel
          assetsTable={{ title: assetsTable.title }}
          flatAssets={flatAssets}
          onSubCount={handleAssetSubCount}
          onTotalCount={handleAssetTotalCount}
        />
      </div>
    </div>
  );
};

export default JordanAirportProfile;